import React, { useState, useEffect } from "react";
import api from "../Services/api";
import "../../assets/css/dist/perguntas-frequentes.dist.css";

const FAQ = (props: any) => {

    const [faqs, setFaqs] = useState<any[]>([]);
    const [uniqueKey, setUniqueKey] = useState<number>(0);
    useEffect(() => {

        api.get(props.url)
            .then(response => {
                let uuid = require("uuid");
                setUniqueKey(uuid)
                setFaqs(response.data.results);
            })
            .catch(error => {
                throw new Error(error);
            });
    }, [props.url]);     
    
  
    function handleClick(params:any) {
        
        var label = "Label_"+params;
        var descricao = "Descricao_"+params;
        
        if (document.getElementById(label)?.classList.contains("active")) {
           
            document.getElementById(label)?.classList.remove("active");
           
            document.getElementById(descricao)?.classList.remove("display");
           
            document.getElementById(descricao)?.classList.add("hide");
            
        } else {
            
            document.getElementById(label)?.classList.add("active");
            
            document.getElementById(descricao)?.classList.add("display");
             
            document.getElementById(descricao)?.classList.remove("hide");
            
        }
    }

    return (
        <main>
            <div className="_the-content">
                <div className='container'>
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="_perguntas pb-10">
                                <div className="tabs">
                                    {faqs?.map((item, index) => (
                                        <div  className="tab mb-8">

                                            <label id={"Label_"+index+uniqueKey} className="tab-label mb-0" htmlFor="question-0" onClick={() =>handleClick(index+uniqueKey)}>
                                                <span className="num"> {index + 1} </span>
                                                <span className="text"> {item.Title} </span>
                                            </label>

                                            <div id={"Descricao_"+index+uniqueKey} className="tab-content bg-light hide">
                                                <p>
                                                    {item.Descricao}
                                                </p>
                                            </div>
                                        </div>

                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );

}
export default FAQ;
